import { useEffect, useRef, useState } from 'react';

const chapters = [
  {
    year: '2020',
    title: 'The Beginning',
    body: 'Syntera Solutions was founded by a group of passionate developers and digital strategists. The goal was simple — bridge the gap between technology and business growth.',
    color: '#FA6E4F',
    img: 'https://readdy.ai/api/search-image?query=modern%20tech%20startup%20team%20collaborating%20in%20dark%20office%2C%20multiple%20monitors%20with%20code%2C%20warm%20lighting%2C%20premium%20IT%20company%20atmosphere%2C%20professional%20photography%2C%20dark%20moody%20background%2C%20editorial%20style&width=700&height=500&seq=about-story-begin-1&orientation=landscape',
  },
  {
    year: '2022',
    title: 'Expanding Horizons',
    body: 'Our expertise covers several key areas: custom software development, IT consulting, and digital marketing & advertising services. We help companies not only create technology products, but also effectively bring them to market, attract users, and scale their business.',
    color: '#F2CF59',
    img: 'https://readdy.ai/api/search-image?query=digital%20marketing%20analytics%20dashboard%20on%20large%20screen%2C%20data%20visualization%2C%20modern%20dark%20office%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20environment%2C%20cinematic%20mood%2C%20premium%20workspace&width=700&height=500&seq=about-story-expand-1&orientation=landscape',
  },
  {
    year: '2024',
    title: 'Full-Cycle Growth',
    body: 'We accompany projects at all stages — from idea and analytics to development, launch, and ongoing support. Thanks to our strong team of specialists, we combine technology and marketing into a unified growth strategy.',
    color: '#8EC9BB',
    img: 'https://readdy.ai/api/search-image?query=team%20celebrating%20successful%20software%20launch%2C%20modern%20tech%20office%2C%20screens%20showing%20application%2C%20warm%20lighting%2C%20professional%20photography%2C%20dark%20moody%20background%2C%20premium%20IT%20company&width=700&height=500&seq=about-story-launch-1&orientation=landscape',
  },
];

export default function AboutStory() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="w-full" style={{ background: '#111' }}>
      {/* Section header */}
      <div className="px-10 lg:px-20 pt-20 pb-16">
        <div className={`transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'}`}>
          <p className="text-[#FA6E4F]/60 text-xs tracking-[0.5em] uppercase mb-6">How it happened</p>
          <h2 className="boldonse text-white leading-none" style={{ fontSize: 'clamp(44px, 6vw, 90px)' }}>
            THE<br />
            <span style={{ color: '#FA6E4F' }}>STORY</span>
          </h2>
        </div>
      </div>

      {/* Chapters */}
      <div className="px-10 lg:px-20 pb-20 flex flex-col gap-8">
        {chapters.map((ch, i) => (
          <div
            key={ch.year}
            className="flex flex-col"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(32px)',
              transition: `all 0.9s ease ${i * 150}ms`,
            }}
          >
            {/* Accent bar */}
            <div className="w-full h-1" style={{ background: ch.color }} />

            {/* Text */}
            <div
              className="w-full flex flex-col justify-center px-10 lg:px-16 py-12"
              style={{ background: '#161616' }}
            >
              <p className="boldonse mb-3" style={{ color: ch.color, fontSize: '13px', letterSpacing: '0.3em' }}>
                {ch.year}
              </p>
              <h3 className="boldonse text-white mb-5" style={{ fontSize: 'clamp(28px, 3.5vw, 52px)', lineHeight: 0.95 }}>
                {ch.title}
              </h3>
              <p className="text-white/55 text-base leading-relaxed max-w-2xl">
                {ch.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}